import { upperCase } from "lodash";

import { CancelIcon } from "./CancelIcon";
import { Caret } from "./Caret";
import { DatePickerIconArrow } from "./DatePicker";
import { DownloadIcon } from "./DownloadIcon";
import { CriticalIcon, WarningIcon } from "./Errors";
import { ExpandIcon } from "./Expand";
import { Eye } from "./Eye";
import { FilterAndSortIcon } from "./FilterAndSortIcon";
import { DoneIcon, LeftIcon, RightIcon } from "./FormIcons";
import { Cancel, TabCancelIcon } from "./Global";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  BubbleAllOut,
  CardView,
  DarkMode,
  Earth,
  EditIcon,
  EyeIcon,
  Filter,
  FlashIcon,
  KeyboardArrowDown,
  KeyboardArrowUp,
  LightMode,
  MergeArrowUp,
  MoneyIcon,
  Mountain,
  RightTriangle,
  SquareBarIcon,
  TabAddIcon,
  TableView,
  TickIcon,
  TrafficLight,
} from "./IconList";
import { Info } from "./InfoNew";
import { Logo } from "./Logo";
import { LogoWithName } from "./LogoWithName";
import { TableFilterIcon } from "./TableFilterIcon";
import { Visibility } from "./Visibility";
import { VisibilityOff } from "./VisibilityOff";

const GetIconByName = (props) => {
  const allIcons = {
    MergeArrowUp: <MergeArrowUp {...props} />, // look like arror up
    RightTriangle: <RightTriangle {...props} />,
    Earth: <Earth {...props} />, // earth
    Money: <MoneyIcon {...props} />,
    TrafficLight: <TrafficLight {...props} />,
    BubbleAllOut: <BubbleAllOut {...props} />,
    Mountain: <Mountain {...props} />,
    EyeIcon: <EyeIcon {...props} />,
    Cancel: <CancelIcon {...props} />, // file upload, it has click event
    TableFilterIcon: <TableFilterIcon {...props} />,
    Caret: <Caret {...props} />,
    TickIcon: <TickIcon {...props} />,
    FlashIcon: <FlashIcon {...props} />,
    TabAddIcon: <TabAddIcon {...props} />,
    Logo: <Logo {...props} />,
    LogoWithName: <LogoWithName {...props} />,
    CardView: <CardView {...props} />,
    TableView: <TableView {...props} />,
    ArrowUpIcon: <ArrowUpIcon {...props} />,
    ArrowDownIcon: <ArrowDownIcon {...props} />,
    SquareBarIcon: <SquareBarIcon {...props} />,
    EditIcon: <EditIcon {...props} />,
    DarkMode: <DarkMode {...props} />,
    LightMode: <LightMode {...props} />,
    KeyboardArrowDown: <KeyboardArrowDown {...props} />,
    KeyboardArrowUp: <KeyboardArrowUp {...props} />,
    Info: <Info {...props} />,
    Visibility: <Visibility {...props} />,
    VisibilityOff: <VisibilityOff {...props} />,
  };
  return allIcons[props?.name] || <></>;
};
const GetIconByPageName = (props) => {
  const key = upperCase(props?.pageName);
  const allIcons = {
    CFO: <MoneyIcon {...props} />,
    REVIEW: <EyeIcon {...props} />,
  };
  return allIcons[key] || <></>;
};

export {
  Cancel,
  CancelIcon,
  CardView,
  Caret,
  CriticalIcon,
  DatePickerIconArrow,
  DoneIcon,
  DownloadIcon,
  ExpandIcon,
  Eye,
  EyeIcon,
  Filter,
  FilterAndSortIcon,
  GetIconByName,
  GetIconByPageName,
  Info,
  LeftIcon,
  RightIcon,
  TabCancelIcon,
  TableFilterIcon,
  Visibility,
  VisibilityOff,
  WarningIcon,
};
